import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const userId = sessionStorage.getItem("userId"); // or auth check

  if (!userId) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;